import { GenIcon } from '../helpers/IconBase.es.js';

const FacebookSquareFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 512 512", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M455.27,32H56.73A24.74,24.74,0,0,0,32,56.73V455.27A24.74,24.74,0,0,0,56.73,480H256V304H202.45V240H256V189c0-57.86,40.13-89.36,91.82-89.36,24.73,0,51.33,1.86,57.51,2.68v60.43H364.15c-28.12,0-33.48,13.3-33.48,32.9V240h67l-8.75,64H330.67V480h124.6A24.74,24.74,0,0,0,480,455.27V56.73A24.74,24.74,0,0,0,455.27,32Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { FacebookSquareFilled };
